<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pldY1y/tc-custom/9781452148496.jpg?1721442314082" alt="This image is the cover for the book Your Inner Critic Is a Big Jerk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Your Inner Critic Is a Big Jerk
      </h1>
      <p class="bookDescription body article font2">
        <b>This charmingly illustrated guide shares ten truths about creativity, confidence, and how you can silence that stifling voice in your head.</b><br/><br/>This book is a salve for creative minds everywhere, and duct tape for the mouth of every artist’s inner critic. Author and art curator Danielle Krysa explores ten essential truths we all must face in order to defeat self-doubt. <br/><br/>Each encouraging chapter deconstructs a pivotal moment on the creative path—fear of the blank page, the dangers of jealousy, sharing work with others—and explains how to navigate roadblocks. Packed with helpful anecdotes, thoughts from successful creatives, and practical exercises gleaned from Danielle Krysa’s years of working with professional and aspiring artists—plus riotously apt illustrations from art world darling Martha Rich—this ebook arms readers with the most essential tool for their toolbox: the confidence they need to get down to business and make good work.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Danielle Krysa, Martha Rich
      </h2>
      
      <p class="authorDescription body article">Danielle Krysa is the writer/curator behind the contemporary art website the Jealous Curator, and the author of Creative Block and Collage. She lives in British Columbia.Martha Rich is a Philadelphia-based fine and commercial artist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?572bf5f6